import { parseMarkers } from '../../../../components/shared/map'
import store from '../../../../admin/store'
import {
    INVESTMENT_STORE_KEY,
    SPORT_VENUES_SET_BUSY,
    SPORT_VENUES_SET_DATA,
    SPORT_VENUES_SET_MARKERS, SPORT_VENUES_TYPES_SET_BUSY, SPORT_VENUES_TYPES_SET_DATA
} from '../../../../admin/reducers/sport-venues-front'
import isIn from 'validator/lib/isIn'
import { FILTER_HASHTAGS_STATE } from '../../../../consts'

const config = window.APP_CONFIG

/**
 * Fetch sport venues
 *
 * @param {string}    sportVenueFilter
 * @param {boolean}   isFilter
 * @param {boolean}   showMap
 * @return {Promise<unknown>}
 */
export const fetchSportVenues = (sportVenueFilter, isFilter, showMap) => {
    const {
        busy,
        limit,
        cursor,
        types,
        sportVenues: sportVenuesStore,
    } = store.getState().sportVenuesFront

    if (busy || cursor === null) {
        return new Promise(resolve => resolve())
    }

    store.dispatch({
        type: SPORT_VENUES_SET_BUSY,
        busy: true,
    })

    const {
        REACT_APP_DEFAULT_CITY_FILTER_NAME: cityFilterName,
        REACT_APP_API_URL: apiUrl,
        REACT_APP_PASS_MARKERS_TO_CITY: passMarkersToCity,
    } = config

    let sportVenues = []

    let includes = [
        'sports',
        'image',
        'locations',
    ]

    if (types.investment.apply) {
        includes.push('hashtags')
    }

    includes = includes.join(',')

    let params = [
        `include=${includes}`,
        `limit=${limit}`,
        `cursor=${cursor || 0}`,
        `${sportVenueFilter}`,
        `investmentProject=${types.investment.apply ? 1 : 0}`,
    ]

    if (cityFilterName) {
        params.push(`city=${cityFilterName}`)
    }

    return window.axios.get(
        `${apiUrl}api/sport-venues?${params.join('&')}`
    ).then(({ data }) => {
        if (!isFilter) {
            sportVenues = sportVenuesStore

            if (data && data.data.length > 0) {
                sportVenues = [...sportVenuesStore, ...data.data]
            }
        } else {
            sportVenues = data.data

            if (cursor > 0) {
                sportVenues = [...sportVenuesStore, ...data.data]
            }
        }

        sportVenues?.forEach?.(sportVenue => {
            if (sportVenue?.hashtags?.data && types?.investment?.filterHashtags) {
                sportVenue.filteredHashtags = sportVenue.hashtags.data.filter(hashtag => isIn(hashtag.key, types.investment.filterHashtags))
            }
        })

        store.dispatch({
            type: SPORT_VENUES_SET_DATA,
            data: {
                sportVenues: sportVenues,
                busy: false,
                cursor: data.meta.cursor.next,
            },
        })

        if (showMap) {
            const markers = parseMarkers({ data: sportVenues }, 'sportVenue', passMarkersToCity)
            store.dispatch({
                type: SPORT_VENUES_SET_MARKERS,
                markers: markers,
            })
        }

        return new Promise(resolve => resolve(sportVenues))
    })
}

/**
 * Fetch data for investments map
 *
 * @param {string} sportVenueFilter
 * @return {Promise}
 */
export const fetchInvestmentsMap = sportVenueFilter => {
    const busy = store.getState().sportVenuesFront.types.investment.busy

    if (busy) {
        return new Promise(resolve => resolve())
    }

    store.dispatch({
        type: SPORT_VENUES_TYPES_SET_BUSY,
        actionType: INVESTMENT_STORE_KEY,
        busy: true,
    })

    const {
        REACT_APP_DEFAULT_CITY_FILTER_NAME: cityFilterName,
        REACT_APP_API_URL: apiUrl,
        REACT_APP_PASS_MARKERS_TO_CITY: passMarkersToCity,
    } = config

    let params = [
        'include=locations',
        `${sportVenueFilter}`,
        'investmentProject=1',  // @TODO - if somebody want this expand to some other types, just refactor this line
    ]

    if (cityFilterName) {
        params.push(`city=${cityFilterName}`)
    }

    return window.axios.get(`${apiUrl}api/sport-venues/all-with-locations?${params.join('&')}`)
        .then(({ data }) => {
            const markers = parseMarkers(data, 'sportVenue', passMarkersToCity)

            store.dispatch({
                type: SPORT_VENUES_TYPES_SET_DATA,
                actionType: INVESTMENT_STORE_KEY,
                data: {
                    investmentsData: data?.data,
                    busy: false,
                    markers: markers,
                },
            })
        })
}

/**
 * Fetch sport venue detail and store it into sport venues types
 *
 * @param {string} sportVenueSlug
 * @param {string} actionType   - definition of store
 * @return {Promise}
 */
export const fetchTypesDetail = (sportVenueSlug, actionType = INVESTMENT_STORE_KEY) => {
    store.dispatch({
        type: SPORT_VENUES_TYPES_SET_BUSY,
        actionType: actionType,
        busy: true,
    })

    return window.axios.get(`${config.REACT_APP_API_URL}api/sport-venues/${sportVenueSlug}?include=sports,locations,image,hashtags`)
        .then(({ data }) => {
            let sportVenue = { ...data?.data }

            if (sportVenue?.hashtags?.data && actionType === INVESTMENT_STORE_KEY) {
                sportVenue.filteredHashtags = sportVenue.hashtags.data.filter(hashtag => isIn(hashtag.key, FILTER_HASHTAGS_STATE))
            }

            store.dispatch({
                type: SPORT_VENUES_TYPES_SET_DATA,
                actionType: actionType,
                data: {
                    activeMarkerVenue: sportVenue,
                    busy: false,
                },
            })
        })
}
